import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import '@/assets/css/common.less';
import '@/assets/css/variable.less';
import '@/styles/base.scss';

import Bus from '@/components/common/bus';

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

// import '@/assets/css/theme/459f75/index.css';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import echarts from 'echarts';
// require('./mock');

import http from "@/utils/request";
Vue.prototype.http = http;


import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

Vue.config.productionTip = false;
Vue.use(ElementUI, {size: 'medium'});
Vue.prototype.$axios = axios; // axios不能使用use
Vue.prototype.$echarts = echarts;

// 使用router.beforeEach注册一个全局前置守卫，对路由进行权限跳转
router.beforeEach((to, from, next) => {
  // 未匹配到路由时 跳转到error页面
  if (0 === to.matched.length) {

    next('/error');
    return false;
  }

  const role = localStorage.getItem('userInfo');
  if (!role && to.path !== '/login') {
    next('/login');
  } else if (to.meta.permission) {
    // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    role === 'admin' ? next() : next('/error');
  } else {
    // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
    if(navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
      Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
        confirmButtonText: '确定'
      });
    } else {
		if(to.path=='/express-single' || to.path=='/express-batch' ||  to.path=='/logistics-single'){
			Bus.$emit('collapse3', 0)
			// localStorage.setItem('collapse',0)
		}else if(to.path=='/all-waybills' || to.path=='/staging-waybills' || to.path=='/order-detail'){
			Bus.$emit('collapse3', 1)
			// localStorage.setItem('collapse',1)
		}else if(to.path=='/subscribe-service' || to.path=='/workorder-list' || to.path=='/select-service' || to.path=='/service-detail'){
			Bus.$emit('collapse3', 2)
			// localStorage.setItem('collapse',2)
		}else if(to.path=='/my-account' || to.path=='/settlement_invoicing' ||  to.path=='/account-detail'){
			Bus.$emit('collapse3', 3)
			// localStorage.setItem('collapse',3)
		}else if(to.path=='/data-board'){
			Bus.$emit('collapse3', 4)
			// localStorage.setItem('collapse',4)
		}else if(to.path=='/modify-password'){
			Bus.$emit('collapse3', 5)
			// localStorage.setItem('collapse',4)
		}else if(to.path=='/payment'){
			Bus.$emit('collapse3', 6)
			// localStorage.setItem('collapse',5)
		}
		
		document.body.scrollTop = 0;
		window.scrollTo(0, 0);
		next();
    }
  }
});

new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js